import topTitle from '@/components/title';
import { invoiceRecordDetail, invoiceOffset } from '../request';
export default {
  components: {
    topTitle
  },
  data() {
    return {
      data: {},
      invoiceTypeList: [{
        key: 'MERGE',
        name: '多笔保单金额汇总开具发票'
      }, {
        key: 'MULTIPLE',
        name: '多笔保单逐笔开具发票'
      }, {
        key: 'SINGLE',
        name: '单笔保单开具发票'
      }],
      tableData: [],
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'customerInsuranceName',
        key: 'customerInsuranceName',
        align: 'center'
      }, {
        slots: {
          title: '保单号'
        },
        dataIndex: 'thirdPolicyNo',
        key: 'thirdPolicyNo',
        align: 'center'
      }, {
        slots: {
          title: '承保单位'
        },
        dataIndex: 'unitName',
        key: 'unitName',
        align: 'center'
      }, {
        slots: {
          title: '承保机构'
        },
        dataIndex: 'agencyName',
        key: 'agencyName',
        align: 'center'
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'premium',
        key: 'premium',
        align: 'center'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      showModal: false,
      confirmLoading: false
    };
  },
  computed: {},
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    getDetail() {
      invoiceRecordDetail({
        invoiceId: this.$route.params.id
      }).then(res => {
        console.log(res);
        this.data = res;
        this.tableData = res.policyList;
      });
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getDetail();
    },
    // 查看发票
    checkInvoice() {
      window.open(this.data.localUrl, '_blank');
    },
    // 发票作废
    async invoiceOffsetConfirm() {
      this.confirmLoading = true;
      await invoiceOffset({
        invoiceId: this.$route.params.id
      }).then(res => {
        this.confirmLoading = false;
        if (!res.code) {
          this.$router.replace({
            path: '/invoiceManage/customerManage/invoiceRecord'
          });
        }
      }).catch(err => {
        this.confirmLoading = false;
      });
      this.showModal = false;
    }
  }
};